import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user')) || '',
};
export const mutations = {

  setToken(state, token) {
    console.log("mi token",token)
    localStorage.setItem('token', token);
    state.token = token;
  },
  setUser(state, user) {
    console.log("mi user",user)
    state.user = user;
    localStorage.setItem("user", JSON.stringify(user));
  },
  AUTH_LOGOUT(state, rootState) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("currentToca");
    delete axios.defaults.headers.common["Authorization"];
  }
};
export const actions = {
  LOGIN({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.login(credentials)
        .then(response => {
          console.log("mi response",response)
           /*if (response.data.two_factor_required) {
            // No se almacena token; se debe proceder al challenge
            //return response;
          } */
          //si viene con two_factor_required lo manejamos desde el disparador del componente
          if(response.data.token && response.data.user)
          {
            commit('setToken', response.data.token);
            commit('setUser', response.data.user);
          }

          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },

  TWOFACTOR_SETUP({ commit }, data) {
    console.log("mi data,", data)
    return new Promise((resolve, reject) => {
      ApiService.get(data)
        .then(response => {
          console.log("mi response Habilitar two factor",response)

          resolve(response);
        })
        .catch(error => {
          console.log("el error de 2fa setup", error)
         // commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  VERIFY_CODE2FA({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(data)
        .then(response => {
          console.log("mi response de verify code 2FA")
          if(response.data.valid) //se logro obtener los codigo entonces actualizamos los datos del user
          {
            //si es vaido el codigo entonces actualizar los datos del user nuevo
            commit('setUser', response.data.user);
          }


          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  LOGOUT({ commit, state }) {
    return new Promise((resolve, reject) => {
      // ApiService.logout({ data: { token: localStorage.getItem('token') } })
      ApiService.logout({ data: { token: state.token } })
        .then(response => {
          commit("AUTH_LOGOUT");
          resolve(response);
        })
        .catch(error => {
          commit("AUTH_LOGOUT");
          reject(error);
        });
    });
  },
  ACTUALIZAR_PASSWORD({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.put(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  VERIFICAR({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
export const getters = {
  isLoggedIn: state => !!state.token,
  getUser: state => state.user,
  currentUser: state => state.user,
  roleUser: state => (state.user && state.user.roles && state.user.roles[0])
    ? state.user.roles[0].name
    : false
};
